/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

export { LocalePrefixProvider, useLocalePrefix } from "./LocalePrefixContext";
export type { LocalePrefixContextValue, LocalePrefixProviderProps } from "./LocalePrefixContext";
